import { MantineProvider } from '@mantine/core';

import Lobby from '~/domains/contest/domains/lobby/components/ConnectedLobby';
import { ContestFilterProvider } from '~/domains/contest/domains/lobby/context/ContestFiltersContext/ContestFiltersContext';

function LobbyPage() {
  return (
    <MantineProvider inherit>
      <ContestFilterProvider>
        <Lobby />
      </ContestFilterProvider>
    </MantineProvider>
  );
}

export default LobbyPage;

LobbyPage.isPublic = true;
LobbyPage.hasAppBanners = false;
LobbyPage.trackingName = 'League Lobby';
